import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_ART_TiposVentas_Listar = async () => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_TiposVentas/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_TiposVentas_Leer = async (CodigoTipoVentas) => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_TiposVentas/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoTipoVentas));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_TiposVentas_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_ART_TiposVentas/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_TiposVentas_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Modificar";

    try {
        await llamadaAPI_PUT("ABM_ART_TiposVentas/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_TiposVentas_Generar_JSON = async (CodigoTipoVentas,
    Descripcion, MultiPlanta, MultiEmpresa, CodigoCuentaContableCompra, CodigoCuentaContableVenta, CodigoSubCCCompra,
    CodigoSubCCVenta, ImprimeEnComandera1, ImprimeEnComandera2, ImprimeEnComandera3, 
    ExcluirDeReporteDeVentasXArticulo, ListPlantas, ListEmpresas) => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Generar_JSON";

    try {

        const listaEmpresasConCodigo = (ListEmpresas && ListEmpresas.length > 0
            ? ListEmpresas
            : [{
                ABM_ZON_Empresas_CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_TiposVentas_CodigoTipoVentas: CodigoTipoVentas,
                Descripcion: "Default"
            }]
        ).map(empresa => ({
            ...empresa,
            ABM_ART_TiposVentas_CodigoTipoVentas: CodigoTipoVentas
        }));

        const listaPlantasConCodigo = (ListPlantas && ListPlantas.length > 0
            ? ListPlantas
            : [{
                ABM_ZON_Plantas_CodigoPlanta: localStorage.getItem("CodigoPlanta"),
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                ABM_ART_TiposVentas_CodigoTipoVentas: CodigoTipoVentas,
                Descripcion: "Default"
            }]
        ).map(planta => ({
            ...planta,
            ABM_ART_TiposVentas_CodigoTipoVentas: CodigoTipoVentas
        }));

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            IdEstado: 10,
            CodigoTipoVentas: CodigoTipoVentas,
            Descripcion: Descripcion,
            MultiPlanta: MultiPlanta,
            MultiEmpresa: MultiEmpresa,
            CodigoCuentaContableCompra: CodigoCuentaContableCompra,
            CodigoCuentaContableVenta: CodigoCuentaContableVenta,
            CodigoSubCCCompra: CodigoSubCCCompra,
            CodigoSubCCVenta: CodigoSubCCVenta,
            ImprimeEnComandera1: ImprimeEnComandera1,
            ImprimeEnComandera2: ImprimeEnComandera2,
            ImprimeEnComandera3: ImprimeEnComandera3,
            ExcluirDeReporteDeVentasXArticulo: ExcluirDeReporteDeVentasXArticulo,
            ListPlantas: listaPlantasConCodigo,
            ListEmpresas: listaEmpresasConCodigo
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_TiposVentas_Eliminar = async (CodigoTipoVentas) => {
    const NombreFuncion = "function_ABM_ART_TiposVentas_Eliminar"

    try {
        const resulData = await llamadaAPI_PUT("ABM_ART_TiposVentas/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            TratamientoDeParametroParaURI(CodigoTipoVentas));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};